import { LoanCrud } from "./loanCrud";

export default function PaidLoan(){
    return <LoanCrud name="回款客户" type="paid" router="paidLoans" />
}